import { jsx as o } from "react/jsx-runtime";
import "react";
import { theme as s } from "../../styles/themes/index.js";
const m = "[&>svg]:fill-inherit", p = ({
  SVGElement: t,
  fill: r = `${s["--ll-color-on-background"]}`,
  className: i,
  height: e = 24,
  width: l = 24
}) => /* @__PURE__ */ o("div", { className: `${i} ${m}`, style: { height: `${e}px`, width: `${l}px`, fill: r }, children: /* @__PURE__ */ o(t, {}) });
export {
  p as SVG
};
